var product='';
var fcstind=0;
var _getDataInProgress = false;
var zoomind=0;
var zoomind_max=0;
var finger_x0=-1;
var finger_y0=-1;
var finger_x=-1;
var finger_y=-1;
var finger_anim=0;
var local_zoom_y=0;
var balayage_S='nil';
var dateo = new Date();    // Date d'origine de la prevision
var datec = new Date();    // Date coutante
dateo.setMinutes(0);
dateo.setSeconds(0);
dateo.setMilliseconds(0);
var gdate_utc_offset=0;
var gxsize=0;
var gysize=0;
var gmobile=0;
window.gstart_from_now = false; // initialisé après chargement des cookies

// Produits qui supportent le HRDPS (surface seulement)
// varMap : data1..5 → clé dans le résultat fetchForecast
// scale  : facteur pour convertir WMS → format MySQL (même échelle que les renderers attendent)
//   tt_prof/es_prof : renderer fait ×0.01  → WMS en °C → stocker ×100
//   apcpn_*        : renderer fait ×0.01  → WMS en mm → stocker ×100
//   uv             : déjà encodé par IMETEO_UV → scale 1
//   gust           : renderer fait ×conv  → WMS en m/s → scale 1 (conv appliqué au rendu)
//   nuage_tot      : renderer utilise direct → scale 1
//   N4 (solaire)   : accumulé en J/m²×1e-4, WMS en W/m² → à implémenter plus tard, scale 1
const HRDPS_PRODUCTS = {
  temp:        { data1: 'TT',  data2: 'ES',  data3: null, data4: null,  data5: null,
                 scale: { TT: 100, ES: 100 } },
  sous_sol:    { data1: 'TT',  data2: 'ES',  data3: null, data4: null,  data5: null,
                 scale: { TT: 100, ES: 100 } },
  solaire:     { data1: 'N4',  data2: null,  data3: null, data4: null,  data5: null,
                 scale: { N4: 1 } },
  vents:       { data1: 'uv',  data2: null,  data3: null, data4: null,  data5: 'WGE',
                 scale: { uv: 1, WGE: 'MS_TO_KT' } },
  roses:       { data1: 'uv',  data2: null,  data3: 'PR', data4: 'WGE', data5: null,
                 scale: { uv: 1, PR: 100, WGE: 'MS_TO_KT' } },
  precip:      { data1: 'PR',  data2: null,  data3: null, data4: null,  data5: null,
                 scale: { PR: 100 } },
  precip_type: { data1: 'RN',  data2: 'FR',  data3: null, data4: 'SN',  data5: null,
                 scale: { RN: 100, FR: 100, SN: 100 } },
  nuages:      { data1: 'NT',  data2: null,  data3: null, data4: null,  data5: null,
                 scale: { NT: 1 } },
};

async function Get_Data(F_product) {
  if (_getDataInProgress) return;
  _getDataInProgress = true;
  suspendResizeListener();
  product=F_product;
  cre_cook("produit",product,100);
  gfonte=lit_cook(product+"_font");
  if(gfonte == ""){gfonte=0;}
  window.buttons?.drawButtons();

  var name1=""
  var name2="None"
  var name3="None"
  var name4="None"
  var name5="None"
  var type=""
  if(product == 'temp'){
    name1='tt_prof';
    name2='es_prof';
    type='sfc';
  } else if(product == 'sous_sol'){
    name1='tt_prof';
    name2='es_prof';
    type='sfc';
  } else if(product == 'solaire'){
    name1='flux_onde_courte';
    type='sfc';
  } else if( product == 'vents'){
    name1='uv_prof';
    name2='tt_prof';
    name3='es_prof';
    name4='p0_for_prof';
    name5='gust';
    type='prof';
  } else if(product == 'profils'){
    name1='uv_prof';
    name2='tt_prof';
    name3='es_prof';
    name4='p0_for_prof';
    type='prof';
  } else if(product == 'roses'){
    name1='uv_prof';
    name2='tt_prof';
    name3='apcpn_pr';
    name4='gust';
    type='prof';
  } else if (product == 'precip') {
    name1='apcpn_pr';
    type='sfc';
  } else if (product == 'precip_type') {
    name1='apcpn_rn';
    name2='apcpn_fr';
    name3='apcpn_pe';
    name4='apcpn_sn';
    type='sfc';
  } else if (product == 'nuages') {
    name1='nuage_tot';
    type='sfc';
  } else {
    alert(product+' pas encore implementer');
  }

  param = "&t="+type+"&lon="+my_lng+"&lat="+my_lat+"&data1="+name1+"&data2="+name2+"&data3="+name3+"&data4="+name4+"&data5="+name5

  const req_rdps = php_url_head + "/select_json.php?system=rdps" + param;
  const req_gdps = php_url_head + "/select_json.php?system=gdps" + param;

  try {
    const varMap = HRDPS_PRODUCTS[product];
    const useHrdps = varMap != null && window.wms_fetchForecast && window.wms_productConfig;

    // Lancer les requêtes MySQL et HRDPS en parallèle
    var hrdpsPromise = null;
    if (useHrdps) {
      draw_wms_progress(0);
      const cfg = window.wms_productConfig(product);
      hrdpsPromise = _fetchHrdpsAvecCache(my_lat, my_lng, cfg);
    }

    // Récupérer RDPS et GDPS sans lever d'exception, pour pouvoir quand même
    // utiliser HRDPS si RDPS/GDPS sont indisponibles.
    const [rdpsResp, gdpsResp] = await Promise.all([fetch(req_rdps), fetch(req_gdps)]);
    var rdpsData = null, gdpsData = null;
    try { if (rdpsResp.ok) rdpsData = await rdpsResp.json(); } catch(e) {}
    try { if (gdpsResp.ok) gdpsData = await gdpsResp.json(); } catch(e) {}
    var rdpsOk = rdpsData && rdpsData.status === 'OK' && Array.isArray(rdpsData.hhh) && rdpsData.hhh.length > 0;
    var gdpsOk = gdpsData && gdpsData.status === 'OK' && Array.isArray(gdpsData.hhh) && gdpsData.hhh.length > 0;

    if (useHrdps) {
      let hrdpsData = null;
      try {
        hrdpsData = await hrdpsPromise;
      } catch (hrdpsError) {
        if (hrdpsError.hors_domaine) {
          console.info("Point hors domaine HRDPS, bascule sur RDPS+GDPS.");
        } else {
          throw hrdpsError;
        }
      }

      if (hrdpsData !== null && rdpsOk && gdpsOk) {
        try {
          get_data_now_three(hrdpsData, rdpsData, gdpsData, product, type, varMap, varMap.scale);
          return;  // rendu réussi avec HRDPS+RDPS+GDPS, ne pas tomber dans get_data_now
        } catch (mergeError) {
          if (mergeError.merge_incompatible) {
            console.warn('Merge RDPS/GDPS incompatible, bascule sur HRDPS seulement :', mergeError.message);
            rdpsOk = false;  // force le chemin HRDPS-seul ci-dessous
          } else {
            throw mergeError;
          }
        }
      }
      if (hrdpsData !== null && (!rdpsOk || !gdpsOk)) {
        // HRDPS disponible mais RDPS/GDPS manquants : afficher HRDPS seul avec avertissement
        var manquants = [!rdpsOk && 'RDPS', !gdpsOk && 'GDPS'].filter(Boolean).join(' et ');
        console.warn(manquants + " indisponible(s), affichage HRDPS seulement.");
        var hrdpsOnlyJson = buildHrdpsOnlyJson(hrdpsData, varMap, varMap.scale, dateo,
                                               name1, name2, name3, name4, name5);
        myJson = hrdpsOnlyJson;
        gdate_utc_offset = dateo.getTimezoneOffset();
        zoomind_max = Math.round(hrdpsOnlyJson.hhh[hrdpsOnlyJson.hhh.length - 1] / 48.);
        draw_product(product);
        var ctx = window.ctx_graph;
        ctx.font = 'italic 13px Arial';
        ctx.fillStyle = 'orange';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'top';
        ctx.fillText(manquants + ' indisponible(s) — données HRDPS seulement', gxsize / 2, gysize * 0.07);
      } else if (rdpsOk && gdpsOk) {
        get_data_now(rdpsData, gdpsData, product, type);
      } else {
        var manquants2 = [!rdpsOk && 'RDPS', !gdpsOk && 'GDPS'].filter(Boolean).join(' et ');
        toutou_xy_erreur(manquants2 + ' indisponible(s)',
                         rdpsData?.error || gdpsData?.error || '');
      }
    } else {
      if (!rdpsOk || !gdpsOk) {
        var manquants3 = [!rdpsOk && 'RDPS', !gdpsOk && 'GDPS'].filter(Boolean).join(' et ');
        toutou_xy_erreur(manquants3 + ' indisponible(s)',
                         rdpsData?.error || gdpsData?.error || 'Réponse invalide');
        return;
      }
      get_data_now(rdpsData, gdpsData, product, type);
    }

  } catch (error) {
    console.error("Erreur lors de la récupération des données :", error);
    console.error("Stack:", error.stack);
    toutou_xy_erreur("Erreur lors de la récupération des données : " + error.message);
  } finally {
    _getDataInProgress = false;
    setTimeout(resumeResizeListener, 500);
  }
}

async function _fetchHrdpsAvecCache(lat, lon, cfg) {
  // 1. Obtenir dateo + grid_point (2 requêtes WMS légères)
  const meta = await window.wms_fetchForecastMeta({ model: 'HRDPS', lat, lon }).data;
  if (meta.grid_point.lon === null || meta.grid_point.lat === null) {
    const err = new Error("Le point sélectionné est hors du domaine du HRDPS");
    err.hors_domaine = true;
    throw err;
  }
  const dateoStr = meta.dateo.toISOString().slice(0, 19) + 'Z';

  // Cle de cache basee sur les variables demandees (triees) plutot que sur le
  // produit, pour que deux produits demandant les memes variables (ex: temp
  // et sous_sol) partagent le meme cache.
  const varsKey = cfg.variables.slice().sort().join(',');

  // 2. Vérifier le cache
  const cacheGetUrl = php_url_head + '/wms_cache.php?action=get'
    + '&model=HRDPS'
    + '&grid_lat=' + meta.grid_point.lat
    + '&grid_lon=' + meta.grid_point.lon
    + '&dateo=' + encodeURIComponent(dateoStr)
    + '&vars=' + encodeURIComponent(varsKey);

  try {
    const cacheResp = await fetch(cacheGetUrl);
    if (cacheResp.ok) {
      const cacheJson = await cacheResp.json();
      if (cacheJson.status === 'HIT') {
        draw_wms_progress(1);
        cacheJson.data.dateo = new Date(cacheJson.data.dateo);
        return cacheJson.data;
      }
    }
  } catch (e) {
    console.warn('Cache WMS GET échoué (ignoré) :', e);
  }

  // 3. Cache miss → fetch WMS complet
  const { data: fetchPromise } = window.wms_fetchForecast({
    model:      'HRDPS',
    variables:  cfg.variables,
    lat, lon,
    hours:        48,
    stepSchedule: [{ until: 12, step: 1 }, { step: 3 }],
    fromNow:      false,
    dateo:        meta.dateo,   // réutiliser le dateo déjà obtenu
    transforms: cfg.transforms,
    onProgress: (pct) => draw_wms_progress(pct),
  });
  const hrdpsData = await fetchPromise;

  // 4. Stocker en cache de façon asynchrone (fire-and-forget)
  fetch(php_url_head + '/wms_cache.php?action=set', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      model:    'HRDPS',
      grid_lat: meta.grid_point.lat,
      grid_lon: meta.grid_point.lon,
      dateo:    dateoStr,
      vars:     varsKey,
      data:     hrdpsData,
    }),
  }).catch(e => console.warn('Cache WMS SET échoué :', e));

  return hrdpsData;
}
function draw_product(prod) {

  const graphiquesChoisis = [prod];
  construireGraphiques(graphiquesChoisis)

  //if      (prod == 'temp')        { toutou_xy_temp(myJson, zoomind); }
  //else if (prod == 'sous_sol')    { toutou_xy_sous_sol(myJson, zoomind); }
  //else if (prod == 'solaire')     { toutou_xy_solaire(myJson, zoomind); }
  //else if (prod == 'vents')       { toutou_xy_vents(myJson, zoomind); }
  //else if (prod == 'profils')     { toutou_xy_profils(myJson, fcstind); }
  //else if (prod == 'roses')       { toutou_xy_roses(myJson, fcstind); }
  //else if (prod == 'precip')      { toutou_xy_precip(myJson, zoomind); }
  //else if (prod == 'precip_type') { toutou_xy_precip_type(myJson, zoomind); }
  //else if (prod == 'nuages')      { toutou_xy_nuages(myJson, zoomind); }
  //else                            { alert(prod + ' pas encore implementer'); }
  //
}

function get_data_now(myJson_rdps, myJson_gdps, product, type){
  // Merge forecasts
  if (!myJson_rdps || myJson_rdps.status !== 'OK') {
    toutou_xy_erreur('ERREUR RDPS : ' + (myJson_rdps?.error || 'Réponse invalide'));
    return;
  }
  if (!myJson_gdps || myJson_gdps.status !== 'OK') {
    toutou_xy_erreur('ERREUR GDPS : ' + (myJson_gdps?.error || 'Réponse invalide'));
    return;
  }
  console.log(myJson_rdps);

  myJson = MergeForecasts(dateo, myJson_rdps, myJson_gdps, type);
  gdate_utc_offset=dateo.getTimezoneOffset();
  zoomind_max=Math.round(myJson.hhh[myJson.hhh.length-1]/48.);
  draw_product(product);
}

function get_data_now_three(hrdpsData, myJson_rdps, myJson_gdps, product, type, varMap, scaleMap) {
  if (!myJson_rdps || myJson_rdps.status !== 'OK') {
    toutou_xy_erreur('ERREUR RDPS : ' + (myJson_rdps?.error || 'Réponse invalide'));
    return;
  }
  if (!myJson_gdps || myJson_gdps.status !== 'OK') {
    toutou_xy_erreur('ERREUR GDPS : ' + (myJson_gdps?.error || 'Réponse invalide'));
    return;
  }
  myJson = MergeThree(dateo, hrdpsData, myJson_rdps, myJson_gdps, type, varMap, scaleMap);
  gdate_utc_offset=dateo.getTimezoneOffset();
  zoomind_max=Math.round(myJson.hhh[myJson.hhh.length-1]/48.);
  draw_product(product);
}

function SetDateo(dateo, fcst){
  year=Math.round(fcst.aaaammjj/10000);
  month=Math.round((fcst.aaaammjj-10000*year)/100)-1;
  day=Math.round((fcst.aaaammjj-10000*year-100*(month+1)));
  dateo.setUTCFullYear(year);
  dateo.setUTCMonth(month);
  dateo.setUTCDate(day);
  dateo.setUTCHours(fcst.hh);
  dateo.setMinutes(0);
  dateo.setSeconds(0);
  dateo.setMilliseconds(0);
  //alert(dateo);
}

Date.prototype.getMois = function() {
  var months = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
  return months[this.getMonth()];
}

Date.prototype.getJour = function() {
  var jours = ["dimanche","lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
  return jours[this.getDay()];
}
Date.prototype.getJourMaj = function() {
  var joursm = ["DIM","LUN", "MAR", "MER", "JEU", "VEN", "SAM"];
  return joursm[this.getDay()];
}

function Set_Product(prod) {
  product=prod;
  Get_Data(product);
}

function Set_Action(action) {
  if( action == 'reculer' || action == 'avancer' ) {
    if (product == 'profils' || product == 'roses'){
      if( action == 'reculer' ){
        fcstind--;
        if(fcstind == -1){fcstind=myJson.hhh.length-1;}
      } else if( action == 'avancer' ){
        fcstind++;
        if(fcstind == myJson.hhh.length){fcstind=0;}
      }
    } else {
      if( action == 'reculer' ){
        zoomind--;
        if(zoomind == -1){zoomind=zoomind_max;}
      } else if( action == 'avancer' ){
        zoomind++;
        if(zoomind > zoomind_max){zoomind=0;}  
      }
    }
    draw_product(product);
  } else if (action == 'fonte'){
    if (typeof window.sidenav_open_fonte === 'function') {
      window.sidenav_open_fonte();
    }
  } else if (action == 'zoom_y'){
    draw_product(product);
  }
}

function toutou_polygone(ctx,xx,yy,filled){
  ctx.beginPath();
  ctx.moveTo(xx[0],yy[0]);
  for(var i=1; i<xx.length; i++){
    ctx.lineTo(xx[i],yy[i]);
  }
  if(filled){
    ctx.fill();
  }else{
    ctx.stroke();
  }
}

function jouleparm2_accumule_a_wattparm2(joule,hhh){
  var ni=hhh.length;
  var res = new Array(ni);
  res[0]=0.;
  for (var i=1; i < ni; i++) {
     // Note les donnees sont en Joule*10e-4/m2 accumulees depuis le debut.
     // On calcul le nombre de watt/m2 moyen dans l'interval de temps.
     // 10000.*(data1[i]-data1[i-1]) = nombre de Joule/m2 dans l'interval
     // 3600*(hhh[i]-hhh[i-1])      = nombre de seconde dans l'enterval
     // Le rappor des deux donne le montre de watt/m2 moyen
     res[i]=Math.max(0.,(joule[i]-joule[i-1])*10000./(3600.*(hhh[i]-hhh[i-1])));
  }
  return res;
}

function toutou_line(ctx,x0,y0,x1,y1){
  ctx.beginPath();
  ctx.moveTo(x0,y0);
  ctx.lineTo(x1,y1);
  ctx.stroke();
}

function toutou_cubic_lag(x,f0,f1,f2,f3,x0,x1,x2,x3){
  p0 =                  (x-x1)/(x0-x1) * (x-x2)/(x0-x2) * (x-x3)/(x0-x3);
  p1 = (x-x0)/(x1-x0) *                  (x-x2)/(x1-x2) * (x-x3)/(x1-x3);
  p2 = (x-x0)/(x2-x0) * (x-x1)/(x2-x1) *                  (x-x3)/(x2-x3);
  p3 = (x-x0)/(x3-x0) * (x-x1)/(x3-x1) * (x-x2)/(x3-x2)                 ;

  return p0*f0 + p1*f1 + p2*f2 +p3*f3;
}

/**spoi
 * Construit un myJson compatible avec les graphiques à partir des données HRDPS seules,
 * quand RDPS et/ou GDPS sont indisponibles.
 */
function buildHrdpsOnlyJson(hrdps, varMap, scaleMap, dateo, name1, name2, name3, name4, name5) {
    dateo.setTime(hrdps.dateo.getTime());
    var d = hrdps.dateo;
    var aaaammjj = d.getUTCFullYear() * 10000 + (d.getUTCMonth() + 1) * 100 + d.getUTCDate();
    var ni = hrdps.hhh.length;
    var result = {
        aaaammjj:   aaaammjj,
        hh:         d.getUTCHours(),
        levs:       [0],
        hhh:        hrdps.hhh.slice(),
        modele:     Array(ni).fill('H'),
        data1_name: name1,
        data2_name: name2,
        data3_name: name3,
        data4_name: name4,
        data5_name: name5,
    };
    ['data1','data2','data3','data4','data5'].forEach(function(dk) {
        var hrdpsKey = varMap[dk];
        if (!hrdpsKey || !hrdps[hrdpsKey]) {
            result[dk] = new Array(ni).fill(null);
            return;
        }
        var scaleVal = (scaleMap && scaleMap[hrdpsKey]) ? scaleMap[hrdpsKey] : 1;
        if (scaleVal === 'MS_TO_KT') scaleVal = window.WMS_MS_TO_KT || (1 / 0.514791);
        result[dk] = hrdps[hrdpsKey].map(function(v) { return v === null ? null : v * scaleVal; });
    });
    return result;
}

/**
 * Fusionne trois sources de prévision :
 *   HRDPS (WMS, 0 à 48h)
 *   RDPS  (MySQL, après 48h à fin RDPS)
 *   GDPS  (MySQL, fin RDPS+1 à fin)
 *
 * @param {object} dateo       - Date d'origine (modifiée par SetDateo)
 * @param {object} hrdps       - résultat de fetchForecast (wms-forecast-client)
 *                               hrdps.hhh, hrdps.TT, hrdps.uv, etc.
 * @param {object} rdps        - JSON MySQL RDPS
 * @param {object} gdps        - JSON MySQL GDPS
 * @param {string} type        - 'sfc' ou 'prof'
 * @param {object} varMap      - mapping nom_data_imeteo → clé dans hrdps
 *                               ex: { data1: 'TT', data2: 'ES' }
 */
function MergeThree(dateo, hrdps, rdps, gdps, type, varMap, scaleMap) {
    // 1. Fusionner RDPS + GDPS normalement
    var rdps_gdps = MergeForecasts(dateo, rdps, gdps, type);

    // 2. Trouver le dernier index HRDPS et l'heure correspondante
    //    (dateo est maintenant calée sur le RDPS par MergeForecasts)
    var _timeo_rdps = dateo.getTime();
    var _timeo_hrdps = hrdps.dateo.getTime();

    // Heures HRDPS exprimées en heures relatives au dateo RDPS
    var hrdps_hhh = hrdps.hhh.map(h => (_timeo_hrdps - _timeo_rdps) / 3600000 + h);

    // Garder seulement les heures HRDPS strictement avant les données RDPS
    var hrdps_end_h = hrdps_hhh[hrdps_hhh.length - 1];
    var i_rdps_start = 0;
    while (i_rdps_start < rdps_gdps.hhh.length && rdps_gdps.hhh[i_rdps_start] <= hrdps_end_h) {
        i_rdps_start++;
    }

    // 3. Construire le hhh et modele fusionnés
    var _hhh = hrdps_hhh.concat(rdps_gdps.hhh.slice(i_rdps_start));
    var ni_hrdps = hrdps_hhh.length;
    var rdps_gdps_modele = rdps_gdps.modele || Array(rdps_gdps.hhh.length).fill('R');
    var _modele = Array(ni_hrdps).fill('H').concat(rdps_gdps_modele.slice(i_rdps_start));

    // 4. Remplir chaque data
    var _fst = {
        aaaammjj:   rdps_gdps.aaaammjj,
        hh:         rdps_gdps.hh,
        levs:       rdps_gdps.levs,
        hhh:        _hhh,
        modele:     _modele,
        data1_name: rdps_gdps.data1_name,
        data2_name: rdps_gdps.data2_name,
        data3_name: rdps_gdps.data3_name,
        data4_name: rdps_gdps.data4_name,
        data5_name: rdps_gdps.data5_name,
    };

    ['data1','data2','data3','data4','data5'].forEach(function(dk) {
        var dataName = rdps_gdps[dk + '_name'];
        var hrdpsKey = varMap[dk];

        if (dataName === 'None' || !hrdpsKey || !hrdps[hrdpsKey]) {
            // Pas de données HRDPS pour cette variable : utiliser RDPS+GDPS directement
            // mais décaler l'index de départ
            var nk = type === 'sfc' ? 1 : rdps_gdps.levs.length;
            var tail = rdps_gdps[dk].slice(i_rdps_start * nk);
            // Remplir la partie HRDPS avec null
            var head = new Array(ni_hrdps * nk).fill(null);
            _fst[dk] = head.concat(Array.from(tail));
            return;
        }

        // WMS = surface seulement (1 valeur/pas de temps)
        // nk_rdps = nombre de niveaux dans le tableau plat RDPS+GDPS pour cette variable
        var nk_rdps = size_nk(dataName, rdps_gdps.levs.length, type);
        var scaleVal = (scaleMap && scaleMap[hrdpsKey]) ? scaleMap[hrdpsKey] : 1;
        if (scaleVal === 'MS_TO_KT') scaleVal = window.WMS_MS_TO_KT || (1 / 0.514791);
        var hrdpsData_sfc = hrdps[hrdpsKey].map(v => v === null ? null : v * scaleVal);
        var isAccum = is_accum(dataName);
        var tail_rdps = rdps_gdps[dk].slice(i_rdps_start * nk_rdps);

        // Étendre les valeurs HRDPS surface au format plat nk_rdps niveaux/pas :
        // niveau 0 = valeur HRDPS, niveaux 1..nk-1 = null (pas de données pression WMS)
        var hrdpsData = [];
        for (var ti = 0; ti < hrdpsData_sfc.length; ti++) {
            hrdpsData.push(hrdpsData_sfc[ti]);
            for (var ki = 1; ki < nk_rdps; ki++) {
                hrdpsData.push(null);
            }
        }

        if (isAccum) {
            // Ajustement à la transition : RDPS(h) - RDPS(h_transition) + HRDPS(h_transition)
            var hrdps_last_val = hrdpsData_sfc[hrdpsData_sfc.length - 1];
            var rdps_at_transition = rdps_gdps[dk][i_rdps_start > 0 ? (i_rdps_start - 1) * nk_rdps : 0];
            var offset = hrdps_last_val - rdps_at_transition;
            var adjusted_tail = Array.from(tail_rdps).map(v => v + offset);
            _fst[dk] = hrdpsData.concat(adjusted_tail);
        } else {
            _fst[dk] = hrdpsData.concat(Array.from(tail_rdps));
        }
    });

    return _fst;
}

function MergeForecasts(dateo, rdps, gdps, type){
    var _fst = {};
    _dateo_gdps = new Date();
    if( rdps.levs.length != gdps.levs.length){
	toutou_xy_erreur("Les donnees du RDPS et du GDPS n'ont pas le meme nombre de niveaux",
			 rdps.levs.length + " pour le RDPS et " + gdps.levs.length + " pour le GDPS");
    }
    SetDateo(dateo, rdps);
    SetDateo(_dateo_gdps, gdps);
    //alert(dateo);
    //alert(_dateo_gdps);
    _timeo_rdps = dateo.getTime();
    _timeo_gdps = _dateo_gdps.getTime();
    _delta = (_timeo_rdps - _timeo_gdps)/3600000.;
    // find the GDPS forecast that match the latest RDPS forecats in time.
    // find the first GDPS forecast after the latest RDPS forecast
    _last_rdps_fst = _timeo_rdps + 3600000 * rdps.hhh[rdps.hhh.length-1]
    i_gdps_match = -1;
    for (i=0; i < gdps.hhh.length; i++) {
	_time_gdps = _timeo_gdps + 3600000 * gdps.hhh[i];
	if( _time_gdps == _last_rdps_fst ){
	    i_gdps_match = i;
	}
	if( _time_gdps > _last_rdps_fst ){
	    break;
	}	    
    }
    i_gdps = i;	
    if( i_gdps == 0){
        const e = new Error("Il manque des prévisions de GDPS pour le calcul");
        e.merge_incompatible = true; throw e;
    }
    if( i_gdps_match == -1){
        const e = new Error("Il n'y a pas de prévision de " + rdps.hhh[rdps.hhh.length-1] + " h pour le GDPS");
        e.merge_incompatible = true; throw e;
    }
    _ni = rdps.hhh.length + gdps.hhh.length - i;
    _nb = _ni;
    _hhh = Array(_nb);
    for (i=0; i < rdps.hhh.length; i++) {
	_hhh[i] = rdps.hhh[i];
    }
    j = i_gdps;
    for (i=rdps.hhh.length; i < _nb; i++) {
        _hhh[i] = gdps.hhh[j] - _delta;
	j++;
    }	
    _data1 = fill_data(rdps.data1_name, rdps.hhh.length, i_gdps_match, i_gdps, rdps.levs.length, rdps.data1, gdps.data1, _ni, type)
    if(rdps.data2_name == "None"){
	_data2 = Array(1)
    } else {
	_data2 = fill_data(rdps.data2_name, rdps.hhh.length, i_gdps_match, i_gdps, rdps.levs.length, rdps.data2, gdps.data2, _ni, type)
    }
    if(rdps.data3_name == "None"){
	_data3 = Array(1)
    } else {
	_data3 = fill_data(rdps.data3_name, rdps.hhh.length, i_gdps_match, i_gdps, rdps.levs.length, rdps.data3, gdps.data3, _ni, type)
    }
    if(rdps.data4_name == "None"){
        _data4 = Array(1)
    } else {
	_data4 = fill_data(rdps.data4_name, rdps.hhh.length, i_gdps_match, i_gdps, rdps.levs.length, rdps.data4, gdps.data4, _ni, type)
    }
    if(rdps.data5_name == "None"){
        _data5 = Array(1)
    } else {
	_data5 = fill_data(rdps.data4_name, rdps.hhh.length, i_gdps_match, i_gdps, rdps.levs.length, rdps.data5, gdps.data5, _ni, type)
    }
    var rdps_modele = rdps.modele || Array(rdps.hhh.length).fill('R');
    var gdps_modele = gdps.modele || Array(gdps.hhh.length).fill('G');
    _fst={'aaaammjj': rdps.aaaammjj,
	  'hh': rdps.hh,
	  'levs': rdps.levs,
	  'hhh': _hhh,
	  'modele': rdps_modele.concat(gdps_modele.slice(i_gdps)),
	  'data1': _data1,
	  'data2': _data2,
	  'data3': _data3,
	  'data4': _data4,
	  'data5': _data5,
	  'data1_name': rdps.data1_name,
	  'data2_name': rdps.data2_name,
	  'data3_name': rdps.data3_name,
	  'data4_name': rdps.data4_name,
	  'data5_name': rdps.data5_name
	 };
    return _fst;
}

function fill_data(name, ni_rdps, i_gdps_match, i_gdps, nlev, f_rdps, f_gdps, ni, type){
    if(name == "None"){
	return Array(1);
    }
    _nk = size_nk(name, nlev, type);
    _accum = is_accum(name);
    _data = Array(ni * _nk);
    ij=0
    for (i=0; i < ni_rdps; i++) {
	for (k=0; k < _nk; k++){
	    _data[ij] = f_rdps[ij];
	    ij++;
	}
    }
    if( _accum ){
	last_rdps_val = f_rdps[f_rdps.length-1];
	gdps_match_val = f_gdps[i_gdps_match];
	ij_gdps = i_gdps * _nk;
        for (i=ni_rdps; i < _ni; i++) {
            for(k=0; k < _nk; k++){
                _data[ij] = last_rdps_val + f_gdps[ij_gdps] - gdps_match_val;
                //_data[ij] = gdps_match_val;
                ij++;
                ij_gdps++;
            }
        }
    } else {
	ij_gdps = i_gdps * _nk;
	for (i=ni_rdps; i < _ni; i++) {
            for(k=0; k < _nk; k++){
		_data[ij] = f_gdps[ij_gdps];
		ij++;
		ij_gdps++;
            }
	}
    }
    return _data;
}

function size_nk(data_name, nlev, type){
    if(type == 'sfc'){
	return 1;
    }
    switch(data_name) {
    case 'tt_prof':
	_nb = nlev;
	break;
    case 'es_prof':
	_nb = nlev;
	break;
    case 'uv_prof':
	_nb = nlev;
	break;
    case 'apcpn_pr':
	_nb = 1;
	break;
    case 'apcpn_rn':
	_nb = 1;
	break;
    case 'apcpn_sn':
	_nb = 1;
	break;
    case 'apcpn_pe':
	_nb = 1;
	break;
    case 'apcpn_fr':
	_nb = 1;
	break;
    case 'p0_for_prof':
	_nb = 1;
        break;
    case 'flux_onde_courte':
	_nb = 1;
        break;
    case 'nuage_tot':
	_nb = 1;
        break;
    case 'gust':
	_nb = 1;
        break;
    default:
	toutou_xy_erreur("Les donnees " + data_name + " ne sont pas definies dans function size_nk");
    }
    return _nb;
}
function is_accum(data_name){
    _accum = false;
    if( data_name == 'apcpn_pr' ||
	data_name == 'apcpn_rn' ||
	data_name == 'apcpn_sn' ||
	data_name == 'apcpn_pe' ||
	data_name == 'apcpn_fr' ||
	data_name == 'flux_onde_courte'){
	_accum = true;
    }
    return _accum;
}

function toutout_cubic_mono(x,y,npt){
  //
  // Auteur Andre Plante pour iMeteo.ca
  //
  // entree
  //        x   : positions 1..n
  //        y   : valeurs   1..n
  //        npt : nombre de points a ajouter entre les points existants
  // sortie
  //        jason.x jason.y 
  // 
  // Reference
  //        http://en.wikipedia.org/wiki/Monotone_cubic_interpolation
  //        http://en.wikipedia.org/wiki/Cubic_Hermite_spline
  // 
  // Note toutou, les tableaux commencent a 0, donc decalage de -1 su i
  //              par rapport aux k dans la note ci-dessous.
  n=x.length;
  // A FAIRE : tester si y est de la meme longueur que x
  //1) Compute the slopes of the secant lines between successive points: 
  var d=new Array(n-1);
  for (var i=0;i<=n-2;i++){
    d[i]=(y[i+1]-y[i])/(x[i+1]-x[i]);
  }
  //2) Initialize the tangents at every data point as the average of the secants, 
  var m=new Array(n);
  for (var i=1;i<=n-2;i++){
    m[i]=.5*(d[i-1]+d[i]);
  }
  m[0]=d[0];
  m[n-1]=d[n-2];
  //3)
  skip=new Array(n);
  for (var i=0;i<=n-2;i++){
    skip[i]=0;
    if(d[i] == 0.){
      skip[i]=1;
      m[i]=0.;
      m[i+1]=0.;
    }
  }
  //4 et 5)
  for (var i=0;i<=n-2;i++){
    if(skip[i] == 0){
      aa=m[i  ]/d[i];
      bb=m[i+1]/d[i];
      lvec2=aa*aa+bb*bb;
      if(lvec2 > 9.){
	tau=3./Math.sqrt(lvec2);
	m[i  ]=tau*aa*d[i];
	m[i+1]=tau*bb*d[i];
      }
    }
  }
  yy=new Array((n-1)*npt+1);
  xx=new Array((n-1)*npt+1);
  ind=0;
  for (var i=0;i<=n-1;i++){
    xx[ind]=x[i];
    yy[ind]=y[i];
    ind=ind+1;
    if(i<n-1){
      for(var j=0;j<=npt-1;j++){
	xx[ind]=x[i]+(j+1)*(x[i+1]-x[i])/(npt+1);
	h=x[i+1]-x[i];
	t=(xx[ind]-x[i])/h;
	t2=t*t;
	t3=t*t*t;
	yy[ind]=
	  ( 2.*t3 - 3.*t2 + 1.)*y[i]     +
	  (    t3 - 2.*t2 + t )*m[i]  *h +
	  (-2.*t3 + 3.*t2     )*y[i+1] +
	  (    t3 -    t2     )*m[i+1]*h;
	ind=ind+1;
      }
    }
  }
  //Fix ad hoc de toutou pour non monotonicite de certain points
  // A enlever si les overshoots sont causes par un bog dans le
  // code ci-haut
  // En premier on clip, on compte le nombre de clip, ce sera le
  // nombre de passe du filtre.
  ind=0;
  filter=new Array(n);
  for (var i=0;i<=n-2;i++){
    ind=ind+1;
    filter[i]=0;
    for(var j=0;j<=npt-1;j++){
      if(y[i]>y[i+1]){
	if(yy[ind]>y[i]){
	  yy[ind]=y[i];
	  filter[i]=filter[i]+1;
	}
	if(yy[ind]<y[i+1]){
	  yy[ind]=y[i+1];
	  filter[i]=filter[i]+1;
	}
      }
      if(y[i]<=y[i+1]){
	if(yy[ind]<y[i]){
	  yy[ind]=y[i];
	  filter[i]=filter[i]+1;
	}
	if(yy[ind]>y[i+1]){
	  yy[ind]=y[i+1];
	  filter[i]=filter[i]+1;
	}	
      }
      ind=ind+1;
    }
  }
  //Appliquer le filtre sur les intervals ou il y a eu clipping.
  ff=new Array(npt+2);
  ind=0;
  for (var i=0;i<=n-2;i++){
    // charger le data a filtre, en incluant un point additionnel de chaque cote.
    if(filter[i]>0){
      for(var j=0;j<=npt+1;j++){
	ff[j]=yy[ind+j];
      }
      for (j=0;j<2*filter[i];j++){
	if(filter[i]>0){
	  for(var k=1;k<=npt;k++){
	    yy[ind+k]=.25*(ff[k-1]+2.*ff[k]+ff[k+1]);	
	  }
	}
	for(var k=1;k<=npt;k++){
	  ff[k]=yy[ind+k];
	}
      }
    }
    ind=ind+1+npt
  }

  return {x:xx,y:yy};

}

function construireGraphiques(graphiquesChoisis) {
  // Vider le conteneur et les données
  const conteneur = document.getElementById('graphiques');
  const largeur = conteneur.clientWidth;
  const hauteur = conteneur.clientHeight;
    
  conteneur.innerHTML = '';
  
  // Réinitialiser pointsData — on repart à zéro
  //Object.keys(pointsData).forEach(k => delete pointsData[k]);
  
  // Reconstruire selon le nouveau choix
  graphiquesChoisis.forEach(prod => {
    // La div qui contient la paire de canvas
    const div = document.createElement('div');
    div.style.position = 'relative';
    div.style.width = largeur + 'px';
    div.style.height = hauteur + 'px';
    div.style.marginBottom = '0px';
    
    // Canvas de fond
    const canvasFond = document.createElement('canvas');
    canvasFond.id = `fond-${prod}`;
    canvasFond.width = largeur;
    canvasFond.height = hauteur;
    canvasFond.style.position = 'absolute';
    
    // Canvas overlay
    const canvasOverlay = document.createElement('canvas');
    canvasOverlay.id = `overlay-${prod}`;
    canvasOverlay.width = largeur;
    canvasOverlay.height = hauteur;
    canvasOverlay.style.position = 'absolute';
    
    // Assembler — ordre important : fond en premier, overlay par-dessus
    div.appendChild(canvasFond);
    div.appendChild(canvasOverlay);
    conteneur.appendChild(div);          // ← div va dans le conteneur

    const ctxOverlay = canvasOverlay.getContext('2d');
    
    canvasOverlay.addEventListener('mousemove', (e) => {
      const rect = canvasOverlay.getBoundingClientRect();
      const mx = e.clientX - rect.left;
      const my = e.clientY - rect.top;
      // trouver le point le plus proche, dessiner sur ctxOverlay

      ctxOverlay.clearRect(0, 0, canvasOverlay.width, canvasOverlay.height);
      draw_hover_info(ctxOverlay,mx,my,prod);
    });
    
    canvasOverlay.addEventListener('mouseleave', () => {
      // effacer l'overlay
      ctxOverlay.clearRect(0, 0, canvasOverlay.width, canvasOverlay.height);
    });

    
    ctx=canvasFond.getContext('2d')
    if      (prod == 'temp')        { toutou_xy_temp(myJson, zoomind, ctx); }
    else if (prod == 'sous_sol')    { toutou_xy_sous_sol(myJson, zoomind, ctx); }
    else if (prod == 'solaire')     { toutou_xy_solaire(myJson, zoomind, ctx); }
    else if (prod == 'vents')       { toutou_xy_vents(myJson, zoomind, ctx); }
    else if (prod == 'profils')     { toutou_xy_profils(myJson, fcstind, ctx); }
    else if (prod == 'roses')       { toutou_xy_roses(myJson, fcstind, ctx); }
    else if (prod == 'precip')      { toutou_xy_precip(myJson, zoomind, ctx); }
    else if (prod == 'precip_type') { toutou_xy_precip_type(myJson, zoomind, ctx); }
    else if (prod == 'nuages')      { toutou_xy_nuages(myJson, zoomind, ctx); }
    else                            { alert(prod + ' pas encore implementer'); }
    
  });
}
      
function draw_hover_info(ctx,mx,my,prod){
  const points = pointsData[prod];
  let nearest = null;
  let minDist = Infinity;
  for (let i = 0; i < points.length; i++) {
    const dx = points[i].x - mx;
    const dy = points[i].y - my;
    const dist = Math.sqrt(dx*dx + dy*dy);
    if (dist < minDist) {
      minDist = dist;
      nearest = points[i];
    }
  }
  if (nearest && minDist < 40) {
    const prod_params=prod+'_params';
    let lignes = [];
    var my_fonts = new Toutou_Fonts();
    if (prod == 'temp'){
      lignes = [
	nearest.tl,
	'Température : ' + nearest.tt.toFixed(1) + ' °C',
	'Point de rosée : ' + nearest.td.toFixed(1) + ' °C',
      ];
      couleurs = ['none',pointsData[prod_params].tt_col, pointsData[prod_params].td_col];
    } else if (prod == 'sous_sol'){
      lignes = [
	nearest.tl,
	'Température : ' + nearest.tt.toFixed(1) + ' °C',
	'Point de rosée : ' + nearest.td.toFixed(1) + ' °C',
	'Point de rosée critique : ' + nearest.td_critique.toFixed(1) + ' °C',
	nearest.message
      ];      
      couleurs = ['none',pointsData[prod_params].tt_col, pointsData[prod_params].td_col, pointsData[prod_params].td_critique_col,nearest.color_code];
    }else if (prod == 'vents'){
      unitJson=toutou_get_option('unite_vent');
      lignes = [nearest.tl,'Vitesse : ' + Math.round(nearest.wd) + ' ' + unitJson.unite];
      couleurs = ['none',pointsData[prod_params].wd_col];
      if(Math.round(nearest.gust) > Math.round(nearest.wd)){
	lignes.push('Rafale : ' + Math.round(nearest.gust) + ' ' + unitJson.unite);
	couleurs.push([pointsData[prod_params].gust_col]);
      }
      lignes.push('Direction : ' + Math.round(nearest.dir) + ' degrés')
      couleurs.push([pointsData[prod_params].dir_col]);
    }else if (prod == 'profils'){
      if (nearest.type == 'profil') {
	var hauteur = Math.round(nearest.heights) + ' m';
	if(nearest.heights == 0){hauteur = 'surface'}
	lignes = ['Température : ' + nearest.tt.toFixed(1) ,
		  'Point de rosée : ' + nearest.td.toFixed(1) ,
		  'vent : ' + Math.round(nearest.wd) + ' ' + unitJson.unite + ', ' +  Math.round(nearest.dir) + ' degrés',
		  'Niveau : ' + nearest.pres.toFixed(1) + ' hPa, ' + hauteur]
	couleurs = [pointsData[prod_params].tt_col, pointsData[prod_params].td_col, 'none', 'none'];	
      } else if (nearest.type == 'tc') {
	lignes = ['Température de convection : ' + nearest.tc.toFixed(1) + ' °C'];
	couleurs = ['none']
      } else if (nearest.type == 'lcl') {
	lignes = ['Niveau de Condensation par Soulèvement : ' + nearest.tt.toFixed(1) + ' °C, ' + nearest.pres.toFixed(0) + ' hPa'];
	couleurs = ['none']
      } else if (nearest.type == 'ccl') {
	lignes = ['Niveau de Condensation par Convection : ' + nearest.tt.toFixed(1) + ' °C, ' + nearest.pres.toFixed(0) + ' hPa'];
	couleurs = ['none']
      }
    }else if (prod == 'precip'){
      lignes = [nearest.tl, 'Accumulation : ' + nearest.pr.toFixed(1) + ' mm',
		'Taux : ' + nearest.rt.toFixed(1) + ' mm sur ' + nearest.interval + ' h'];
      couleurs = ['none',pointsData[prod_params].pr_col, pointsData[prod_params].rt_col];
    }else if (prod == 'precip_type') {
      lignes = [nearest.tl, 'Accumulation totale    : ' + nearest.pr.toFixed(1) + ' mm'];
      couleurs = ['none',pointsData[prod_params].pr_col];
      count=0;
      if(nearest.rn > 0.){
	lignes.push('Accumulation pluie     : ' + nearest.rn.toFixed(1) + ' mm');
	couleurs.push(pointsData[prod_params].rn_col);
      }else{
	count++;
	nom='pluie'
      }
      if(nearest.sn > 0.){
	lignes.push('Accumulation neige    : ' + nearest.sn.toFixed(1) + ' mm');
	couleurs.push(pointsData[prod_params].sn_col);
      }else{
	count++;
	nom='neige';
      }
      if(nearest.fr > 0.){
	lignes.push('Accumulation verglas : ' + nearest.fr.toFixed(1) + ' mm');
	couleurs.push(pointsData[prod_params].fr_col);
      }else{
	count++;
	nom='verglas';
      }
      if(nearest.pe > 0.){
	lignes.push('Accumulation grésil    : ' + nearest.pe.toFixed(1) + ' mm');
	couleurs.push(pointsData[prod_params].pe_col);
      }else{
	count++;
	nom='grésil'
      }
      if(count == 1 ){
	lignes.push("L'accumulation de " + nom + ' est nul');
	couleurs.push('none');
      }else if (count > 1){
	lignes.push('Les accumulations des autres types sont nuls')
	couleurs.push('none');
      }
      if(count == 3){
	// On enlève le total, car un seul type presente
	lignes.splice(1, 1);
	couleurs.splice(1, 1);
      }
      
    }else if (prod == 'nuages'){
      lignes = [nearest.tl, 'Couver nuageux : ' + Math.round(nearest.pourcent) + ' %'];
      couleurs = ['none',pointsData[prod_params].nuages_col];
    }else{
      alert(prod + ' pas encore implementer dans draw_hover_info');
    }

    const largeur = Math.max(...lignes.map(t => ctx.measureText(t).width)) + 2*my_fonts.hover_pixel;
    // For profils, offset hover box down so it is below the horizontal line crossing the graph.
    if(prod == 'profils'){
      y_offset=my_fonts.hover_pixel
    }else{
      y_offset=0.;
    }
    // Draw translicide box to write hover info
    ctx.shadowBlur = 10;
    ctx.shadowColor = 'rgba(0, 0, 0, 0.3)';
    ctx.fillStyle = 'rgba(255, 255, 255, 0.75)';
    const box_width = my_fonts.hover_pixel * lignes.length * 1.2
    if(nearest.x+largeur > pointsData[prod_params].xmax_pix){
      // draw box left of point
      ctx.fillRect(nearest.x - (.5*my_fonts.hover_pixel+largeur), nearest.y - my_fonts.hover_pixel + y_offset, largeur, box_width);
    }else{
      // draw box right of point
      ctx.fillRect(nearest.x + .5*my_fonts.hover_pixel, nearest.y - my_fonts.hover_pixel + y_offset, largeur, box_width);
    }
    // Write text in hover box
    ctx.shadowBlur = 0; // réinitialiser pour ne pas affecter le texte
    ctx.fillStyle = 'black';
    ctx.font = my_fonts.hover;
    if(nearest.x+largeur > pointsData[prod_params].xmax_pix){
      // Write text left of point
      lignes.forEach((texte, i) => {
	index = i;
	// draw color square in front of text
	ctx.fillStyle = couleurs[i];
	ctx.strokeStyle = couleurs[i];
	if(couleurs[i] != 'none'){
	  ctx.fillRect(nearest.x - largeur, nearest.y + (i-.5)*my_fonts.hover_pixel + y_offset, .5*my_fonts.hover_pixel, .5*my_fonts.hover_pixel)
	}
	ctx.fillStyle = 'black'
	ctx.strokeStyle = 'black'
	ctx.fillText(texte, nearest.x - largeur + my_fonts.hover_pixel, nearest.y + i*my_fonts.hover_pixel + y_offset);
      });
    }else{
      // Write text right of point
      lignes.forEach((texte, i) => {
	index = i;
	// draw color square in front of text
	ctx.fillStyle = couleurs[i];
	ctx.strokeStyle = couleurs[i];
	if(couleurs[i] != 'none'){
	  ctx.fillRect(nearest.x + my_fonts.hover_pixel, nearest.y + (i-.5)*my_fonts.hover_pixel + y_offset, .5*my_fonts.hover_pixel, .5*my_fonts.hover_pixel)
	}
	ctx.fillStyle = 'black'
	ctx.strokeStyle = 'black'
	ctx.fillText(texte, nearest.x + 2*my_fonts.hover_pixel, nearest.y + i*my_fonts.hover_pixel + y_offset );
      });
    }
    // Ligne grise pour hover info
    ctx.beginPath();
    ctx.fillStyle = 'grey';
    ctx.strokeStyle = 'grey';
    if(prod == 'profils'){
      // Ligne horizontale 
      ctx.moveTo(pointsData[prod_params].xmin_pix,nearest.y);
      ctx.lineTo(pointsData[prod_params].xmax_pix,nearest.y);     
    } else {
      // Ligne verticale
      ctx.moveTo(nearest.x,pointsData[prod_params].ymax_pix);
      ctx.lineTo(nearest.x,pointsData[prod_params].ymin_pix);
    }
    ctx.stroke();
  }

  // Un cercle rouge qui suite la souris
  //ctx.clearRect(0, 0, canvasOverlay.width, canvasOverlay.height);
  //ctx.beginPath();
  //ctx.arc(mx, my, 10, 0, 2 * Math.PI);
  //ctx.fillStyle = 'red';
  //ctx.fill();
  
}
